import { SubmissionError } from 'redux-form';
import { browserHistory } from 'react-router';
import RestFactory from '../rest/RestFactory';
import Messages from '../common/validation/Messages';
import ContactUsUtils from '../components/ContactUs/ContactUsUtils';
import WidgetMode from '../components/ContactUs/WidgetMode';

// const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
const validateInput = (values) => {
  if (!values.caseCategory) {
    throw new SubmissionError({
      caseCategory: Messages.REQUIRED_MESSAGE,
      _error: Messages.REQUIRED_MESSAGE
    });
  }
  if (!values.caseSubcategory) {
    throw new SubmissionError({
      caseSubcategory: Messages.REQUIRED_MESSAGE,
      _error: Messages.REQUIRED_MESSAGE
    });
  }
};

/**
 * @param field the form field static definitions.
 * @param value the name value pair for the form attribute submitted in the form.
 * @returns true if field and field value should be sent to the backend.
 */
const isIncludedAttribute = (field, value, widgetMode) => {
  let isIncluded = (
    field.fieldType !== 'plaintext'
    && field.fieldType !== 'submit-button'
    // Excluded attributes that have no value.
    && value
  );
  if (value) {
    if (widgetMode === WidgetMode.smartModem.name) {
      isIncluded = !(WidgetMode.smartModem.excludedFields.includes(field.name));
    } else if (widgetMode === WidgetMode.hg659.name) {
      isIncluded = !(WidgetMode.hg659.excludedFields.includes(field.name));
    } else {
      isIncluded = !(WidgetMode.default.excludedFields.includes(field.name));
    }
  }
  return isIncluded;
};

const getRequestBody = (values) => {
  const requestBody = {
    contactIndividualFullName: values.name,
    contactMobileNumber: values.phone,
    emailAddress: values.email,
    incidentCategory: `${values.caseCategory} : ${values.caseSubcategory}`,
    isClosedByUser: false
  };

  let message = '';
  const customFields = ContactUsUtils.getCustomFields(values.caseCategory, values.caseSubcategory);
  if (customFields) {
    customFields.forEach((field) => {
      const name = field.name;
      const value = values[name];
      if (isIncludedAttribute(field, value, values.widgetMode)) {
        message = `${message}${name}: ${value}\n`;
      }
    });
    if (values.widgetMode === WidgetMode.smartModem.name || values.widgetMode === WidgetMode.hg659.name) {
      message = `Modem Type: ${values.widgetMode}\n${message}`;
    }
  }
  requestBody.message = `${message}\n${values.message}`;
  return requestBody;
};

const submitCase = (values) => {
  const entity = getRequestBody(values);
  return RestFactory.getDefaultRest()({
    method: 'POST',
    path: '/api/customer-self-management/rest/customerSelfManagement/customer/newcase',
    entity
  }).then((response) => {
    validateInput(values);
    if (!response.entity) {
      throw new SubmissionError({
        error: 'Contact Us Submission Failed',
        _error: 'Contact Us Submission Failed please try again'
      });
    }
    browserHistory.push('/contact-success');
    return response;
  }).catch((error) => {
    throw new SubmissionError({
      error,
      _error: 'Contact Us Submission Failed please try again'
    });
  });
};

const ContactUsService = { submitCase, getRequestBody };

export default ContactUsService;



/** WEBPACK FOOTER **
 ** ./src/services/ContactUsService.js
 **/